import useQueryVendorsByType from '@hooks/networkElements/useQueryVendorsByType';

import { IAlarmFilter } from '@interfaces/alarms/alarm';

import useQueryNetworkElementsConnections from './useQueryNetworkElementsConnections';
import useQueryNetworkElementsEstablished from './useQueryNetworkElementsEstablished';
import useQueryNetworkElementsMiddleware from './useQueryNetworkElementsMiddleware';
import useQueryNetworkElementsSubscriptions from './useQueryNetworkElementsSubscriptions';
import useQueryNetworkElementsTypes from './useQueryNetworkElementsTypes';

interface IUseNetworkElementsFilter {
	filtersList: IAlarmFilter[];
	isLoadingFilters: boolean;
}

export const useNetworkElementsFilters = (): IUseNetworkElementsFilter => {
	const { middlewareOptions, isLoadingMiddlewareOptions } = useQueryNetworkElementsMiddleware();
	const { typeOptions, isLoadingTypeOptions } = useQueryNetworkElementsTypes();
	const { connectionOptions, isLoadingConnectionOptions } = useQueryNetworkElementsConnections();
	const { subscribeOptions, isLoadingSubscribeOptions } = useQueryNetworkElementsSubscriptions();
	const { establishedOptions, isLoadingEstablishedOptions } = useQueryNetworkElementsEstablished();
	const { vendorOptions, isLoadingVendorOptions } = useQueryVendorsByType();

	const filtersList = [
		{
			name: 'type',
			placeholder: 'Type',
			data: typeOptions,
		},
		{
			name: 'vendor',
			placeholder: 'Vendor',
			data: vendorOptions,
		},
		{
			name: 'middlewareId',
			placeholder: 'Middleware',
			data: middlewareOptions,
		},
		{
			name: 'establishConnection',
			placeholder: 'Enable',
			data: establishedOptions,
		},
		{
			name: 'status',
			placeholder: 'Connection status',
			data: connectionOptions,
		},
		{
			name: 'subscription',
			placeholder: 'Subscription',
			data: subscribeOptions,
		},
	];

	return {
		filtersList,
		isLoadingFilters: isLoadingMiddlewareOptions ||
			isLoadingTypeOptions ||
			isLoadingConnectionOptions ||
			isLoadingEstablishedOptions ||
			isLoadingSubscribeOptions ||
			isLoadingVendorOptions,
	};
};
